/**
 * @see README.md
 * @run `pnpm generate-schema`
 * @src https://github.com/drwpow/openapi-typescript
 */

import type { components } from '~/types/openapi-generated'

type schemas = components['schemas']

export type Configuration3dBody = schemas['ConfigurationRequest']

export type OptionsBody = schemas['MetaAttributeChangeRequest']

export type Configuration = schemas['ConfigurationResponse']

export type SurfacesOption = schemas['SurfacesOptionResponse']

export type SceneObject = schemas['SceneObjectResponse']

export type Transform = schemas['TransformResponse']

export type Children = schemas['ChildrenResponse']

export type Objects = (Children | SceneObject)[]

export type Material = schemas['MaterialResponse']
export type Materials = Material[]

export type Configuration3d = schemas['Configuration3dResponse']

export type UserConfigurationBody = schemas['UserConfigurationRequest']
export type UserConfigurationSlug = schemas['UserConfigurationSlugResponse']
export type UserConfiguration = schemas['UserConfigurationResponse']
export type UserConfigurationDetails =
  schemas['UserConfigurationDetailsResponse']

export type AccessoriesChangeBody = schemas['ConfiguratorChangeRequest']
export type AccessoriesChange = schemas['AccessoriesChangeResponse']

export type Surface = {
  name: string
  value: string
  thumbnail: string
}

export type Option = {
  name: string
  options: OptionsItem[]
  id: number
  value: OptionsItem
}

export type Options = Option[]

export type OptionsItem = {
  name: string
  value: string
  thumbnail?: string
}

export type SurfacesMapValue =
  Configuration['surfaceTypes'][number]['surfaceCategories'][number]['surfaceCollections'][number]['surfaces'][number]

export type SurfaceCollectionsMapValue = Omit<
  Configuration['surfaceTypes'][number]['surfaceCategories'][number]['surfaceCollections'][number],
  'surfaces'
> & {
  surfaces: Map<number, SurfacesMapValue>
}

export type SurfaceCategoriesMapValue = Omit<
  Configuration['surfaceTypes'][number]['surfaceCategories'][number],
  'surfaceCollections'
> & {
  surfaceCollections: Map<number, SurfaceCollectionsMapValue>
}

export type SurfaceTypesMapValue = Omit<
  Configuration['surfaceTypes'][number],
  'surfaceCategories'
> & {
  surfaceCategories: Map<number, SurfaceCategoriesMapValue>
}

export type SurfaceParents = {
  typeNid: number
  categoryNid: number
  collectionNid: number
} & {}

export type SurfaceCollectionParents = {
  typeNid: number
  categoryNid: number
} & {}

export type SurfaceCategoryParents = {
  typeNid: number
} & {}

export type SurfaceMaps = {
  surfaceCategories: Map<number, SurfaceCategoryParents>
  surfaceCollections: Map<number, SurfaceCollectionParents>
  surfaces: Map<number, SurfaceParents>
}

export type SurfaceOptionsGroup = {
  icon: Configuration['surfaceTypes'][number]['icon'] | undefined
  surfaceOptionGroups: Map<number, SurfaceOptionGroups>
} & {}

export type SurfaceOptionGroups = {
  surfaceType:
    | Pick<Configuration['surfaceTypes'][number], 'nid' | 'title'>
    | undefined
  surfaceOptions: Configuration['surfacesOptions']
} & {}

export function isSceneObject(
  object: SceneObject | Children
): object is SceneObject {
  return (object as SceneObject).geometry !== undefined
}
